import type { HomePageBody } from 'services/freeform';
import type { HeadObject } from 'services/generic';

import { Seo } from 'core/mancity/components/general/seo';

import { CustomMetaData } from '@home/components/custom-meta-data';
import { HomePage } from '@home/components/home-page';

type HomePageViewProps = {
	body: HomePageBody;
	metaData: HeadObject | null;
};

export function HomePageView({ body, metaData }: HomePageViewProps) {
	return (
		<>
			{metaData ? <Seo head={metaData} /> : null}
			<HomePage body={body} />
			<CustomMetaData metadata={metaData} />
		</>
	);
}
